<template>
  <div class="ids-network-error" style="height: 100%">
    <div class="information">
      <div align="center">
        <img src="imgs/svg/icon_networkerror.svg" />
      </div>
      <p>{{ $t('网络请求失败') }}</p>
      <p>
        <span>{{ errorCN }}</span>
      </p>
      <v-btn class="button_refresh" @click="Refresh()">{{ $t('重试') }}</v-btn>
    </div>
  </div>
</template>

<script>
import msgbus from '../msgBus'
import TipsList from '../config/TipsList'
import dateHelper from '../util/date'
import dbHelper from '../util/db'
import tools from '../util/tools'
import funcListConfig from '../funcListConfig'
import operations from '../operations'
import functions from '../functions'
import APP_CONFIG from '../config/App'

export default {
  name: 'iDS-NetworkError',
  data: () => ({}),
  computed: {
    errorCN() {
      if (this.$route.params.err) {
        var err = this.$route.params.err
        var prefix = err.prefix
        var error = TipsList[err.toString()]
        if (!error) {
          if (err.response) {
            error = TipsList[prefix + err.response.data.message]
          }
          if (!error) {
            error = TipsList[prefix + err.message]
          }
          if (!error) {
            if (
              err.message ===
              'timeout of ' + APP_CONFIG.timeout + 'ms exceeded'
            ) {
              error = TipsList['Error: timeout of ms exceeded']
            }
          }
        }
        var errorCN = error ? error.text.cn : ''
        return errorCN
      }
    },
  },
  methods: {
    mSetParams(funcList) {
      var func = funcList[0]

      switch (func.id) {
        case operations.eCreateBottomsByRoles:
          func.params.roles = msgbus.vm.getUserRoles()
          break
      }
      return funcList
    },
    mGetResult(funcList) {
      return funcList
    },

    Refresh() {
      // window.location.href = '/'

      // 检查并刷新登陆权限
      console.log('调试代码')
      // 获取Token及Token过期时间
      var expire = dbHelper.get('expire')
      expire = dateHelper.string2Timestamp(expire)
      var now = dateHelper.getLocalTimestamp()
      var tid = dbHelper.get('tid')

      if (now > expire) {
        // 清空localstorage里用户相关的数据，包含清token
        dbHelper.restore()
        // 跳转登录页面
        this.$router.replace({ name: 'pwdlogin' })
      } else {
        tools.startFuncList(msgbus, this, funcListConfig.common.refreshToken)
      }
    },
  },
  created: function () {
    console.log('代码调试')
    if (this.$route.params.err == null) {
      window.location.href = '/'
      return
    }
  },
}
</script>

<style lang="scss">
.ids-network-error {
  display: flex;
  justify-content: center;
  align-items: center;

  .information {
    p {
      font-size: 1.5rem;
      text-align: center;

      span {
        color: gray;
      }
    }

    .button_refresh {
      background: rgb(48, 133, 214);
      border: 1px solid rgb(48, 133, 214);
      border-radius: 24px;
      display: block;
      margin: 0 auto;
    }
  }
}
</style>
